module.exports = function() {
  return new Worker(__webpack_public_path__ + "0d38bee14d15f2641c79.worker.js");
};